export default {
  SET_PERSONS (state, persons) {
    state.persons = persons
  },
  SET_PERSON (state, person) {
    state.persons.push(person)
  },
  SET_PERSON_BY_ID (state, person) {
    state.person = person
  },
  UPDATE_PERSON (state, person) {
    const { userPersonId } = person
    const index = state.persons.findIndex((e) => e.userPersonId === userPersonId)
    if (index !== -1) {
      Object.assign(state.persons[index], person)
    }
  },
  DELETE_PERSON (state, personId) {
    const index = state.persons.findIndex((e) => e.userPersonId === personId)
    state.persons.splice(index, 1)
  }
}
